
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getCompanySet, modifyCompanySet } from '@/api/system';
import { getUserInfo } from '@/api/users';

@Component({
  name: 'SystemSettingSpareParts',
  components: {
  }
})
export default class extends Vue {
  // 备件设置
  private sparePartsForm: any = {
    isNewSpareParts: false
  }

  created() {
    this.getCompanySet();
  }
  private getCompanySet() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.vip_level = (UserModule.company as any).vip_level;
    getCompanySet(params).then(res => {
      if (res.data && res.data.companySet) {
        this.sparePartsForm.isNewSpareParts = parseInt(res.data.companySet.is_new_spare_parts) === 1;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private sparePartsChange() {
    let params:any = {};
    params.is_new_spare_parts = this.sparePartsForm.isNewSpareParts ? '1' : '0';
    this.modifyCompanySet(params);
  }
  private modifyCompanySet(pamars:any) {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      ...pamars
    };
    modifyCompanySet(params).then(res => {
      this.showSuccessMsg((res as any).msg);
      setTimeout(async() => {
        let parameters: any = {};
        parameters.user_id = UserModule.getUserId;
        parameters.company_id = UserModule.getCompanyId;
        await getUserInfo(parameters).then(async(res) => {
          await UserModule.setLogin(res.data);
        });
        window.location.reload();
      }, 100);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
